export default __webpack_public_path__ + "static/media/fusia-01-b.8e221758.png";